import { fork, call, put, select } from 'redux-saga/effects'
import { takeLatest } from 'redux-saga'

import * as fromUser from '@src/redux/modules/user'
import * as fromAuth from '@src/redux/modules/auth'
import { users } from '@src/services/api'

// /////////////////////////////////////////////////////////////////////////////
// Sagas
// /////////////////////////////////////////////////////////////////////////////
export function * fetch (action) {
  const { id } = action.payload

  yield put({ type: fromUser.FETCH_STARTED })

  const { response, error } = yield call(users.fetch, id)
  if (error) {
    return yield put({
      type: fromUser.FETCH_FAILURE,
      payload: error,
      error: true
    })
  }

  yield put({
    type: fromUser.FETCH_SUCCESS,
    payload: response
  })
}

export function * fetchNextServices (action) {
  yield put({ type: fromUser.FETCH_NEXT_SERVICES_STARTED })

  const userId = yield select(fromAuth.getCurrentUser)

  const { response, error } = yield call(users.fetchNextServices, userId)
  if (error) {
    return yield put({
      type: fromUser.FETCH_NEXT_SERVICES_FAILURE,
      payload: error,
      error: true
    })
  }

  yield put({
    type: fromUser.FETCH_NEXT_SERVICES_SUCCESS,
    payload: response
  })
}

export function * fetchAfterLoginSuccess (action) {
  action.payload.id = action.payload.userId
  yield call(fetch, action)
}

// /////////////////////////////////////////////////////////////////////////////
// Watchers
// /////////////////////////////////////////////////////////////////////////////
export function * watchFetch () {
  yield fork(takeLatest, fromUser.FETCH, fetch)
}

export function * watchFetchNextServices () {
  yield fork(takeLatest, fromUser.FETCH_NEXT_SERVICES, fetchNextServices)
}

export function * watchAuthSuccess () {
  yield fork(takeLatest, fromAuth.LOGIN_SUCCESS, fetchAfterLoginSuccess)
}

// /////////////////////////////////////////////////////////////////////////////
// Root Saga
// /////////////////////////////////////////////////////////////////////////////
export default function * rootSaga () {
  yield * [
    fork(watchFetch),
    fork(watchFetchNextServices),
    fork(watchAuthSuccess)
  ]
}



// WEBPACK FOOTER //
// ./src/redux/sagas/user.js